import {Action} from 'redux';
import initialState from '../initialState';
import {NotificationActions} from './notification/notification-actions';
import {AppDispatch} from './index';
import {extractError} from '../utils/errorHelper';
import { getApi } from '../api/ApiProvider';

export enum MessageActionTypes {

    SAVE_REQUEST = '[FCM][SAVE] Request',
    SAVE_RESPONSE = '[FCM][SAVE] Response',
    SAVE_ERROR = '[FCM][SAVE] Error',

}

export interface IFCMStore {
    send: {
        fetching: boolean,
        error?: any,
        data?: any
    }
}

export default (state: IFCMStore = initialState.fcm, action?: Action<MessageActionTypes> & { payload: any }) => {

    if (!action) {
        return state;
    }

    switch (action.type) {

        case MessageActionTypes.SAVE_REQUEST:
            return {...state, send: {fetching: true}};

        case MessageActionTypes.SAVE_RESPONSE:
            return {...state, send: {fetching: false, data: action.payload}};

        case MessageActionTypes.SAVE_ERROR:
            return {...state, send: {fetching: false, error: action.payload}};

        default:
            return state;
    }
};

export class MessageActions {

    save(data: any) {
        return (dispatch: AppDispatch) => {
            const notif = new NotificationActions();

            dispatch({type: MessageActionTypes.SAVE_REQUEST});

            getApi().fcm().save(data).then(response => {
                dispatch(notif.addSuccess('Mensajes', `Mensaje enviado ${response.code}`));
                dispatch({type: MessageActionTypes.SAVE_RESPONSE, payload: response});
            }).catch(err => {
                dispatch(notif.addError('Mensajes', 'Mensaje no enviado'));
                dispatch({type: MessageActionTypes.SAVE_ERROR, payload: extractError(err)});
            })

        }
    }

}



// WEBPACK FOOTER //
// ./src/store/fcm.ts